const isEmpty = (sources: ImageSourceSets) => {
    return (
        !sources ||
        Object.values(sources).every(
            (source) => Object.keys(source as string[]).length === 0,
        )
    );
};

export const handleThumbnail = (article: InboxArticle) => {
    if (article?.listingSize === "small" && !isEmpty(article.thumbnailAlt)) {
        return article;
    }

    const thumbnailEntry = article?.heroImage ?? article?.thumbnail;

    const thumbnail = {
        title: thumbnailEntry?.large?.title ?? "",
        width: 320,
        height: 320,
        path: thumbnailEntry?.large?.path
            ?.replace(/w=\d+/, "w=320")
            .replace(/h=\d+/, "h=320")
            .replace(/f=\w+/, "f=right"),
    };

    return {
        ...article,
        thumbnailAlt: {
            large: thumbnail,
            largeRetina: thumbnail,
            medium: thumbnail,
            mediumRetina: thumbnail,
            small: thumbnail,
            smallRetina: thumbnail,
        },
    };
};
